import { Box, LinearProgress, styled, Typography } from '@mui/material'
import { color } from 'config/color'
import { type ErrorMessageType } from 'containers/Services/component/ServiceForm'
import type React from 'react'

interface StepperProps {
    numOfSteps: number
    activeStep: number
    errorMessage: ErrorMessageType | undefined
}

const Circle = styled(Box)<{ active: boolean, error: boolean }>(({ active, error }) => ({
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: active ? (error ? color.error[500] : color.success[500]) : color.grey[300],
    border: `solid 3px ${color.white}`
}))


const Stepper: React.FC<StepperProps> = ({ numOfSteps, activeStep, errorMessage }: StepperProps) => {
    const progress = Math.round((activeStep / (numOfSteps - 1)) * 100)

    return (
        <Box display="flex" position="relative" my={2} alignItems="center">
            <Box width="98%">
                <Box flex={1} position="relative">
                    <LinearProgress aria-label={`Service step ${activeStep + 1}`} variant="determinate" value={progress} sx={{
                        height: 6,
                        backgroundColor: color.grey[300],
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: (errorMessage != null) ? color.error[500] : color.success[500]
                        }
                    }} />

                    <Box display="flex" justifyContent="space-between" position="absolute" bottom={-6} left={0} right={0}>
                        {Array.from({ length: numOfSteps }).map((_, index) => (
                            <Circle error={errorMessage != null && index <= activeStep} active={index <= activeStep} key={index} />
                        ))}
                    </Box>
                </Box>
            </Box>
            <Typography ml={1} fontSize={14} color={color.grey[700]}>{`${progress}%`}</Typography>


        </Box>
    )
}

export default Stepper
